<template>
  <div>
  <!-- 회원 등록 다이올로그 -->
    <v-overlay :z-index="5000" :value="bLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="bDialog"  max-width="600px" persistent>
      <v-card flat tile ref="form">
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="blue--text text--darken-2 font-weight-bold">
            <v-icon class="mr-2" color="primary">how_to_reg</v-icon>회원가입
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-2 mr-2"></v-divider>

        <v-card-text v-if="bCardOrder == 1" class="pr-4 pl-4 pb-6 mt-4">
          <v-row>
            <v-col cols="12" class="pb-0">
              <div class="text-subtitle-1 grey--text text--darken-2 font-weight-bold">
                업체검색
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.cCorpNm" @keyup.enter="SearchCorpDialog()" @click:append-outer="SearchCorpDialog()" :readonly="editedItem.cCorpId != ''" append-outer-icon="search" dense ref="CorpNmKorRef">
                <template v-slot:label>
                  소속 업체명<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" align="left">
              <v-btn @click="$emit('CloseLogin')" text class="hidden-xs-only text-subtitle-1 grey--text pa-0 pl-2 pr-2 text--darken-3"><v-icon >post_add</v-icon>협력업체 등록</v-btn>
              <v-btn @click="$emit('CloseLogin')" text class="hidden-sm-and-up text-subtitle-1 grey--text pa-0 pl-2 pr-2 text--darken-3 mt-n8"><v-icon >post_add</v-icon>협력업체 등록</v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="12" align="right" class="pt-0 pb-0">
              <v-divider class="ma-2 mt-0"></v-divider>
              <v-btn @click="Close()" class="mr-2" text><v-icon class="mr-1">mdi-close</v-icon>닫기</v-btn>
              <v-btn @click="Nextpage1()" class="ml-2" dark><v-icon class="mr-1">mdi-chevron-right</v-icon>다음</v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- <v-card-text v-if="bCardOrder == 3" class="pr-4 pl-4 pb-6 mt-4">
          <v-row>
            <v-col cols="12" class="pb-0">
              <div class="text-subtitle-1 grey--text text--darken-2 font-weight-bold">
                본인 인증
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field :loading="bSending" @click:append-outer="ResistByPhone()" @keyup.enter="ResistByPhone()" v-model="editedItem.cTel" append-outer-icon="send" dense class="mb-n2" placeholder="010********" hint="[ '-' 제외하고 숫자만 입력 ]" ref="CodeRef">
                <template v-slot:label>
                  휴대전화<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="cCode" hint="[ 6자리 숫자 ]" ref="cCodeRef" @keyup.enter="Nextpage2()">
                <template v-slot:label>
                  인증번호<strong class="red--text">*</strong>
                </template>
                <template v-slot:append>
                  <div v-if="bAuthIng">
                    <v-icon @click="Nextpage2()" class="mr-2">mdi-check</v-icon>
                    {{cCertifyTime}}
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" align="right" class="pt-0 pb-0">
              <v-divider class="ma-2 mt-0"></v-divider>
              <v-btn @click="Close()" class="mr-2" text><v-icon class="mr-1">close</v-icon>닫기</v-btn>
              <v-btn @click="Nextpage2()" class="ml-2" dark><v-icon class="mr-1">mdi-chevron-right</v-icon>다음</v-btn>
            </v-col>
          </v-row>          
        </v-card-text> -->
        <v-card-text v-if="bCardOrder == 3" class="pa-4 pb-6">
          <v-row>
            <v-col cols="12" class="">
              <div class="text-subtitle-1 grey--text text--darken-2 font-weight-bold">
                회원정보 입력
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cCorpNm" disabled>
                <template v-slot:label>
                  업체명<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="d-flex">
              <v-text-field dense class="mb-n2" :value="editedItem.cCustomNickId" @keyup="filteringHandlerId" hint="영문+숫자 (5자 이상)" @keyup.enter="CheckCustomId()" ref="IdRef">
                <template v-slot:label>
                  아이디<strong class="red--text">*</strong>
                </template>
              </v-text-field>
              <v-btn @click="CheckCustomId()" class="ml-2 mt-1 pl-2 pr-2" dark small><v-icon class="mr-1" small>check</v-icon>중복확인</v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field :value="editedItem.cPwd" @keyup="filteringHandler" @keyup.enter="$refs.CheckPwdRef.focus()" v-on:keyup.ctrl="CopyByCtrlC($event,editedItem.cPwd)" class="mb-n2" :class="{'test_password_style' : bPwShow1}" dense hint="Essential" ref="PwdRef">
                <template v-slot:label>
                  <div style="-webkit-text-security: none;">비밀번호<strong class="red--text">*</strong></div>
                </template>
                <template v-slot:message="{   }">
                  <div style="-webkit-text-security: none;">영문+숫자 (10자리 ~ 30자리) 또는 영문+특수기호 (10자리 ~ 30자리) 또는 영문+숫자+특수기호(8자리 ~ 30자리)</div>
                </template>
                <template v-slot:append>
                  <div style="-webkit-text-security: none;">
                    <v-icon @click="bPwShow1 = !bPwShow1">{{cIconText1}}</v-icon>
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <!-- <v-text-field :value="editedItem.cRePwd" @keyup="filteringHandlerCheck" @keyup.enter="$refs.CustomNmRef.focus()" class="mb-n2 input_english" :class="{'test_password_style' : bPwShow2}" dense ref="CheckPwdRef"> -->
              <v-text-field :value="editedItem.cRePwd" @keyup="filteringHandlerCheck" @keyup.enter="$refs.EmailRef.focus()" v-on:keyup.ctrl="CopyByCtrlC($event,editedItem.cRePwd)" class="mb-n2 input_english" :class="{'test_password_style' : bPwShow2}" dense ref="CheckPwdRef">
                <template v-slot:label>
                  <div style="-webkit-text-security: none;">비밀번호 확인<strong class="red--text">*</strong></div>
                </template>
                <template v-slot:append>
                  <div style="-webkit-text-security: none;">
                    <v-icon @click="bPwShow2 = !bPwShow2">{{cIconText2}}</v-icon>
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete v-model="editedItem.cNational" :items="zNational" no-data-text="일치하는 국가가 없습니다." dense hint="1~20자의 한글로 입력" persistent-hint>
                <template v-slot:label>
                  국적<strong class="red--text">*</strong>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <!-- <v-text-field dense class="mb-n2" v-model="editedItem.cCustomNm" ref="CustomNmRef" @keyup.enter="$refs.BirthRef.focus()"> -->
              <v-text-field dense class="mb-n2" v-model="editedItem.cCustomNm" @keyup.enter="$refs.BirthRef.focus()" :disabled="editedItem.cCustomNm != ''">
                <template v-slot:label>
                  성명<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cBirth" placeholder="YYYYMMDD" ref="BirthRef" :disabled="editedItem.cBirth != ''" maxlength="10">
                <template v-slot:label>
                  생년월일<strong class="red--text">*</strong>
                </template>
              </v-text-field>
              <!-- <v-text-field dense class="mb-n2" v-model="editedItem.cBirth" placeholder="YYYYMMDD" ref="BirthRef" @keyup.enter="$refs.EmailRef.focus()">
                <template v-slot:label>
                  생년월일<strong class="red--text">*</strong>
                </template>
              </v-text-field> -->
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cTel" :disabled="editedItem.cAuthType == 'P'" persistent-placeholder>
                <template v-slot:label>
                  휴대전화<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cEmail" ref="EmailRef" @keyup.enter="$refs.PartNmRef.focus()">
                <template v-slot:label>
                  메일주소<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cPartNm" ref="PartNmRef" @keyup.enter="$refs.LevNmRef.focus()">
                <template v-slot:label>
                  부서명<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cLevNm" ref="LevNmRef" @keyup.enter="SetCustom()">
                <template v-slot:label>
                  직위<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">                      
              <v-file-input     
                show-size
                v-model="NowSelFile"
                accept="image/png"
                :persistent-hint="true"
                v-on:change="onSelFile(NowSelFile, 1)"          
                label="증명사진"
                hint="Essential"
                >
                  <template v-slot:message="{ }">
                    <div style="line-height:120%;">
                      JPG,JPEG,PNG,GIF파일만 첨부하세요. 다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
                      <div class="blue--text text--darken-2">방문기간이 2일 이상일 경우에는 반드시 증명사진이 첨부 되어야 합니다.</div>
                      (첨부 할 수 있는 파일의 최대 크기는 10MB까지 입니다)<br>
                    </div>
                  </template>
                </v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-card flat outlined>
                <v-img contain height="120" :src="sNowPath"/>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="12" align="right" class="pt-0 pb-0">
              <v-divider class="ma-2 mt-0"></v-divider>
              <v-btn @click="Close()" class="mr-2" width="100px" text><v-icon class="mr-1">mdi-close</v-icon>닫기</v-btn>
              <v-btn @click="SetCustom()" class="ml-2" width="100px" dark><v-icon class="mr-1">save</v-icon>저장</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <ResistPledgeDialog ref="ResistPledgeDialogRef" v-if="bAgree == true" @ClosePledge="ClosePledge" @FailAuth="Close"/>
    <SearchCorp ref="SearchCorpRef" @GetCorpInfo="GetCorpInfo"/>
  </div>
</template>

<script>
import BasicInfo from "../BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';
import Util from "../Util.js";
import { mapState } from "vuex";

import SearchCorp from "./SearchCorp.vue";
import ResistPledgeDialog from "../components/ResistPledgeDialog.vue";

export default {
  components: {
    SearchCorp,
    ResistPledgeDialog,
  },
  
  data: () => ({
    password : null,
    hidePassword: false,
    bSending: false,
    bDialog : false,
    bPwShow1: true, 
    bPwShow2: true,
    // cCheckModel: "cPhone",
    cCode: "",            //입력코드
    bLoading: false,         //인증번호 PASS
    NowSelFile : null,
    bAgree : false,
    bCheckId : false,
    sNowPath : "",
    bCardOrder : 0,

    bAuthIng : false,
    bAuthPass : false,
    // interval : {},
    // cCircularTime : 0,
    // cCertifyTime : "",
    Result: {
      cCode : ""
    },

    oCheckEmail : {
      bResult : false,
      cEmail : "",
    },

    // rules : {},

    editedItem: {
      cCustomNickId : "",
      cNewCustomId : "",
      cEditCustomId : "",
      cNational : "대한민국",
      cCustomNm : "",
      cPwd : "",
      cRePwd : "",
      cEmail : "",
      cTel : "",
      cBirth: "",
      cLevNm : "",
      cCorpId : "",
      cCorpNm : "",
      cPartNm : "",
      cPledge1 : "Y",
      cPledge2 : "Y",
      cPledge3 : "Y",
      cPledge4 : "N",
      cPledge5 : "N",
      cPledge6 : "N",
      cFileId : "NONE",
      cCreateDateTime: "",
      cUpdateDateTime: "",
      cLocal: "",
      cAuthType : "",
      cAuthDI : "",
    },
    defaultItem: {
      cCustomNickId : "",
      cNewCustomId : "",
      cEditCustomId : "",
      cNational : "대한민국",
      cCustomNm : "",
      cPwd : "",
      cRePwd : "",
      cEmail : "",
      cTel : "",
      cBirth: "",
      cLevNm : "",
      cCorpId : "",
      cCorpNm : "",
      cPartNm : "",
      cPledge1 : "Y",
      cPledge2 : "Y",
      cPledge3 : "Y",
      cPledge4 : "N",
      cPledge5 : "N",
      cPledge6 : "N",
      cFileId : "NONE",
      cCreateDateTime: "",
      cUpdateDateTime: "",
      cLocal: "",
      cAuthType : "",
      cAuthDI : "",
    },
  }),
      
  computed: {
    ...mapState(["zNational","FMaxSize3","zFileType","cAES256Encrypt"]),
    cIconText1() {
      return this.bPwShow1 ? "mdi-eye-off": "mdi-eye"
    },
    cIconText2() {
      return this.bPwShow2 ? "mdi-eye-off": "mdi-eye"
    }
  },
  
  created() {
  },

  methods: {
    CopyByCtrlC(event,value) {
      if (event.key.toUpperCase() == "C") {
        navigator.clipboard.writeText(value)
      }
    },

    filteringHandlerId(e) {
      this.bCheckId = false;
      let ResultWord = e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '')
      this.$refs.IdRef.lazyValue = ResultWord
      this.editedItem.cCustomNickId = ResultWord
    },
    filteringHandler(e) {
      let ResultWord = e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '')
      this.$refs.PwdRef.lazyValue = ResultWord
      this.editedItem.cPwd = ResultWord
    },
    filteringHandlerCheck(e) {
      let ResultWord = e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '')
      this.$refs.CheckPwdRef.lazyValue = ResultWord
      this.editedItem.cRePwd = ResultWord
    },
    // 회원가입 페이지 열기
    Open() {
      this.bDialog = true;
      this.Initialize();
      this.bCardOrder = 1;

      // this.cCertifyTime = "";

      setTimeout(() => {
        this.$refs.CorpNmKorRef.focus()
      }, 10);
    },

    // 회원가입 페이지 열기 (사업자번호 가져온후)
    OpenRun(zData) {
      this.bDialog = true;
      this.Initialize();
      this.bCardOrder = 1;
      // this.cCertifyTime = "";

      this.editedItem.cCorpId = zData.cCorpId;
      this.editedItem.cLocal = zData.cLocal;
      this.editedItem.cCorpNm = zData.cCorpNm;
    },

    // 초기화
    Initialize() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.bPwShow1= true; 
      this.bPwShow2= true;
      this.cCode = "";
    },

    Nextpage1() {
      if (this.editedItem.cCorpId == "") {
        EventBus.$emit("onShowMsgBox", "업체정보가 없습니다.", "협력업체를 검색 후 선택하여 주세요.");
        this.$refs.CorpNmKorRef.focus()
        return
      }
      this.bCardOrder = 0;
      this.bAgree = true;
      setTimeout(() => {
        this.$refs.ResistPledgeDialogRef.Open()  
      }, 10);
    },
    
    ClosePledge(oData) {
      this.ResistByPhone(oData);
      // this.bAgree = false;
      // this.bCardOrder = 3;
      
      // this.editedItem.cCustomNm = oData.RSLT_NAME;
      // this.editedItem.cBirth = oData.RSLT_BIRTH.replace(/-/g,'');
      // this.editedItem.cTel = oData.TEL_NO.replace(/-/g,'');
          
      // EventBus.$emit("onShowMsg",false,  "본인인증이 완료 되었습니다.");
      // setTimeout(() => {
      //   this.$refs.IdRef.focus()
      // }, 10);
    },

    // CountTime() {
    //   this.cCircularTime = 180
    //   this.cCertifyTime = "3:00"
    //   this.interval = setInterval(() => {
    //     this.cCircularTime -= 1
    //     this.cCertifyTime = Util.ChangeNumToMin(this.cCircularTime)
    //     if (this.cCircularTime == 0) {
    //       this.ResetCertify()
    //       clearInterval(this.interval)
    //     }
    //   }, 1000)
    // },

    ResetCertify(){
      this.bAuthIng = false;
      this.cCode = ""
    },

    CheckCustomId() {
      this.bCheckId = false;

      this.editedItem.cCustomNickId = this.editedItem.cCustomNickId.replace(/(\s*)/g,'');
      var check1 = /^(?=.*[a-zA-Z])(?=.*[0-9]).{5,20}$/.test(this.editedItem.cCustomNickId);
      if (!check1) {
        EventBus.$emit("onShowMsgBox", "아이디의 형식이 올바르지 않습니다.", "아이디는 5~20자의 영문과 숫자의 조합으로 설정해주세요.");
        return;
      }

      var posData = {
        cCustomNickId : this.editedItem.cCustomNickId,
      };

      axios
        .post(BasicInfo.UIL_API + "CheckCustomId", posData, {
          headers: {
          }
        })
        .then(res => {
          if (res.data.ResultCd === "00") {              
            EventBus.$emit("onShowMsg", false, res.data.Msg);            
            this.bCheckId = true;
          } else {
            EventBus.$emit("onShowMsgBox", "회원가입이 불가능한 아이디 입니다.", res.data.Msg);
            this.editedItem.cCustomNickId = "";
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    // 서버에 파일 올리기
    bSendSvrFile(SelFile){      
      var d = new Date();
      var Year = d.getFullYear(); 
      
      var fileName = SelFile.name;
      var Extend = Util.getExtension(fileName).toUpperCase();           // 확장자 가져오고, 대문자로 변환
      var sFileTypeId = Util.sGetId(Util.sGetFileType(SelFile.type));   // 파일타입 가져오고, 앞번호(Id) 저장
        
      let formData = new FormData();                                    // 아스키코드가 아닌 파일전송시, 사용
      formData.append('uploadfile', SelFile);                           // (파일명, 파일)로 구성 
      return new Promise((resolve) => (                                 // API 주소에 추가적인 정보를 넣어서 파일과 같이 보냄
        axios.
        post(BasicInfo.UIL_API + "UploadFile?PublicFile=Y&Year="+Year+"&FileNm="+fileName+"&Extend="+Extend+"&MimeType="+SelFile.type+"&Size="+SelFile.size+"&FileTypeId="+sFileTypeId , 
          formData, 
          {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
        .then(res => {   
          resolve(res);            
        })
        .catch(err =>{
          this.bLoading = true;
          resolve(null);
          EventBus.$emit("onShowMsg",true, "File Send Error-Network Error!"+err);
        })
      ));                
    },

    onSelFile(NowSelFile) {
      let bFileType = false

      if (NowSelFile != null)  {
        if (NowSelFile.size > this.FMaxSize3)  {
          this.sNowPath = ""
          setTimeout(() => {
            this.NowSelFile = null;
          }, 300);
          EventBus.$emit("onShowMsgBox","첨부하신 파일의 용량의 크기를 확인하여 주세요.","첨부하실수 있는 파일의 크기는 최대 10MB까지 입니다.");
          return
        }

        for ( let i in this.zFileType) {
          if (this.zFileType[i] == NowSelFile.type) {
            bFileType =  true;
            break
          }
        }
      } else {
        bFileType = true
        this.sNowPath = ""
      }

      if (!bFileType) {
        setTimeout(() => {
          this.NowSelFile = null;
        }, 300);
        EventBus.$emit("onShowMsgBox","첨부하신 파일의 형식을 확인하여 주세요.","첨부하실수 있는 파일의 형식은 JPG,JPEG,PNG,GIF 입니다.");
        return
      }

      const reader = new FileReader
      reader.onload = e => {
        var imageData = e.target.result;
        this.sNowPath = imageData;
      }
      try {
        reader.readAsDataURL(NowSelFile)
      } catch (error) {
        EventBus.$emit("onFileBus", true,""+error);
      }
    },

    async SetCustom() {
      this.editedItem.cCustomNickId = Util.RemoveBlank(this.editedItem.cCustomNickId)
      this.editedItem.cPwd = Util.RemoveBlank(this.editedItem.cPwd)

      if (this.editedItem.cCorpNm == "" ) {
        EventBus.$emit("onShowMsgBox", "업체명은 필수입력 항목입니다.","업체명 항목을 확인하여 주세요.");
        return;
      }
      if (this.editedItem.cCustomNickId == "" ) {
        EventBus.$emit("onShowMsgBox", "아이디는 필수입력 항목입니다.","아이디 항목을 확인하여 주세요.");
        return;
      }
      if (this.bCheckId == false) {
        EventBus.$emit("onShowMsgBox", "아이디가 중복되었는지 확인이 필요합니다.","아이디를 입력 후 중복확인 버튼을 눌러 중복되었는지 확인하여 주세요.");
        return;
      }      
      if (!/^(?=.*[a-zA-Z])(?=.*[0-9]).{5,20}$/.test(this.editedItem.cCustomNickId)) {
        EventBus.$emit("onShowMsgBox", "아이디의 형식이 올바르지 않습니다.","아이디는 5~20자의 영문과 숫자의 조합으로 설정해주세요.");
        return;
      }
      if (!/^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣].{1,20}$/.test(this.editedItem.cNational)) {
        EventBus.$emit("onShowMsgBox", "국적이 선택되지 않았습니다.","국적 항목을 확인하여 주세요.");
        return;
      }
      if (this.editedItem.cCustomNm == "" ) {
        EventBus.$emit("onShowMsgBox", "성명은 필수입력 항목입니다.","성명 항목을 확인하여 주세요.");
        return;
      }
      if (this.editedItem.cBirth == "" ) {
        EventBus.$emit("onShowMsgBox", "생년월일은 필수입력 항목입니다.","생년월일 항목을 확인하여 주세요.");
        return;
      }
      if (!this.CheckBirth()) {
        return
      }

      let cCheckTel = this.editedItem.cTel.replace(/(\s*)/g,'')

      if (cCheckTel == "") {
        EventBus.$emit("onShowMsgBox", "휴대전화 번호는 필수입력 항목입니다.","휴대전화 항목을 확인하여 주세요.");
        return;
      }
      if (!/^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/.test(cCheckTel)) {
        EventBus.$emit("onShowMsgBox", "전화번호가 정확하지 않습니다.","['-' 제외하고 숫자만 입력해주세요.]");
        return;
      }

      if (this.editedItem.cEmail == "" ) {
        EventBus.$emit("onShowMsgBox", "이메일은 필수입력 항목입니다.","이메일 항목을 확인하여 주세요.");
        return;
      }
      
      this.oCheckEmail = Util.CheckEmail(this.editedItem.cEmail)
      if (!this.oCheckEmail.bResult) {
        EventBus.$emit("onShowMsgBox", "이메일 주소가 정확하지 않습니다.","입력하신 이메일을 확인하여 주세요.");
        return;
      }
      this.editedItem.cEmail = this.oCheckEmail.cEmail

      if (this.editedItem.cPartNm == "" ) {
        EventBus.$emit("onShowMsgBox", "부서명은 필수입력 항목입니다.","부서명 항목을 확인하여 주세요.");
        return;
      }
      if (this.editedItem.cLevNm == "" ) {
        EventBus.$emit("onShowMsgBox", "직위는 필수입력 항목입니다.","직위 항목을 확인하여 주세요.");
        return;
      }

      if (this.editedItem.cPwd == "" ) {
        EventBus.$emit("onShowMsgBox", "비밀번호는 필수입력 항목입니다.","비밀번호 항목을 확인하여 주세요.");
        return;
      }
      if (this.editedItem.cRePwd != this.editedItem.cPwd ) {
        EventBus.$emit("onShowMsgBox", "비밀번호가 일치하지 않습니다.","입력하신 비밀번호가 일치하는지 확인하여 주세요.");
        return;
      }

      let TestBirth = this.editedItem.cBirth.substring(5,7) + this.editedItem.cBirth.substring(8,10)

      if (!this.CheckPW(this.editedItem.cPwd, this.editedItem.cCustomNickId, TestBirth)) {
        return;
      }

      this.bLoading = true;
      if (this.NowSelFile !== null) {          
        var res = await this.bSendSvrFile(this.NowSelFile);

        if (res.data.ResultCd == "00") {
          this.editedItem.cFileId = res.data.FileId;
        } else {
          EventBus.$emit("onShowMsg",true, "File Send Error-Network Error!");
          this.bLoading = false;
          return;
        }            
      }

      this.bLoading = false;
      if (this.editedItem.cCorpId == "" || this.editedItem.cCorpId == "0") this.editedItem.cCorpId = "NONE"
      
      var posData = {
        cCustomNickId : this.editedItem.cCustomNickId,
        cNational : this.editedItem.cNational,
        cCustomNm: this.editedItem.cCustomNm,
        cPwd : this.cAES256Encrypt(this.editedItem.cPwd),
        cEmail : this.editedItem.cEmail,
        cTel : cCheckTel,
        cBirth : Util.sTenLenghtDate(this.editedItem.cBirth),
        cLevNm : this.editedItem.cLevNm,
        cCorpId: this.editedItem.cCorpId,
        cPartNm : this.editedItem.cPartNm,
        cPledge1 : this.editedItem.cPledge1,
        cPledge2 : this.editedItem.cPledge2,
        cPledge3 : this.editedItem.cPledge3,
        cPledge4 : this.editedItem.cPledge4,
        cPledge5 : this.editedItem.cPledge5,
        cPledge6 : this.editedItem.cPledge6,
        cFileId : this.editedItem.cFileId,
        cAuthType: this.editedItem.cAuthType,
        cAuthDI: this.editedItem.cAuthDI,
        cCode: this.editedItem.cCode,
      };
      
      axios
        .post(BasicInfo.UIL_API + "SetCustom", posData, {
          headers: {
            //"Authorization": this.$store.state.UserInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd === "00") {
            this.$emit("GoResistLogin",this.editedItem)
            this.Close();
            EventBus.$emit("onShowMsg",false, "회원가입이 완료되었습니다.");
          } else if (res.data.ResultCd == "02") {
            EventBus.$emit("onShowMsgBox","아이디 또는 전화번호가 중복된 회원이 있습니다.", "아이디 또는 전화번호를 확인 후 다시 입력하여 주세요.");
          } else if (res.data.ResultCd == "11") {
            EventBus.$emit("onShowMsgBox","인증 절차를 진행하여 주세요.", "휴대전화 인증은 최대 3분까지 유효합니다.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },


    // 비밀번호 유효성검사
    CheckPW(cPwd,cCustomNickId,cBirth) {
      if(!Util.CheckPWFormNew(cPwd)){
        EventBus.$emit("onShowMsgBox","비밀번호 형식이 잘못 되었습니다.", "비밀번호는 영문+숫자(10자리 ~ 30자리) 또는 영문+특수기호(10자리 ~ 30자리) 또는 영문+숫자+특수기호(8자리 ~ 30자리)로 설정해주세요.");
        return false;
      }

      if(/(\w)\1\1/.test(cPwd)){
        EventBus.$emit("onShowMsgBox","비밀번호 형식이 잘못 되었습니다.", "비밀번호는 같은 문자를 3번 이상 사용하실 수 없습니다.");
        return false;
      }

      if(cPwd.search(cCustomNickId)>-1){
        EventBus.$emit("onShowMsgBox","비밀번호 형식이 잘못 되었습니다.", "비밀번호에 아이디가 포함되었습니다.");
        return false;
      }

      if(cPwd.search(cBirth)>-1){
        EventBus.$emit("onShowMsgBox", "비밀번호 형식이 올바르지 않습니다.","비밀번호에 생년월일이 포함되었습니다.");
        return false;
      }

      return true;
    },

    // 생년월일 유효성검사
    CheckBirth() {
      var birth = this.editedItem.cBirth
      var year = this.editedItem.cBirth.substring(0,4)
      var month = this.editedItem.cBirth.substring(4,6)
      var day = this.editedItem.cBirth.substring(6,8)

      var check1 = /^(19[0-9][0-9]|2\d{3})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/.test(birth);              //숫자 (8자리)

      if(!(check1)){
        EventBus.$emit("onShowMsgBox","생년월일 형식이 잘못 되었습니다", "생년월일을 (년도)(월)(일) 양식에 맞춰 입력해주세요.");
        return false;
      }

      if(month <1 || month >12){
        EventBus.$emit("onShowMsgBox","생년월일 형식이 잘못 되었습니다.", "생년월일 중 월 부분을 확인해 주세요.");
        return false;
      }

      if(day <1 || day >31){
        EventBus.$emit("onShowMsgBox","생년월일 형식이 잘못 되었습니다.", "생년월일 중 일 부분을 확인해 주세요.");
        return false;
      }

      if((month==4 || month==6 || month==9 || month==11) && day==31){
        EventBus.$emit("onShowMsgBox","생년월일 형식이 잘못 되었습니다.", "4,6,9,11월은 30일 까지 있습니다.");
        return false;
      }

      if(month=="02"){
        var isleap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0));  //윤년(4로 나눠지는해, 4,100으로 나눠지는해는 아님, 4,100,400나눠지는 해)
        if (day > 28 && !isleap) {
          EventBus.$emit("onShowMsgBox","생년월일 형식이 잘못 되었습니다.", "해당 년도의 2월은 28일까지 있습니다.");
          return false;
        } else if (day > 29 && isleap) {
          EventBus.$emit("onShowMsgBox","생년월일 형식이 잘못 되었습니다.", "해당 년도의 2월은 29일까지 있습니다.");
          return false;
        }
      }

      if(!Util.s14OldCheck(this.editedItem.cBirth)) {
        EventBus.$emit("onShowMsgBox","만 14세 미만의 사용자 입니다.", "만 14세 미만의 사용자는 회원가입을 진행 할 수 없습니다.");
        return false;
      }

      return true;
    },
    
    ResistByPhone(oData) {
      let cRePhoneNum = ""

      if (oData.AuthType == "P") {
        cRePhoneNum = oData.TEL_NO.replace(/-/g,'')

        if (cRePhoneNum == "") {
          EventBus.$emit("onShowMsgBox","전화번호 형식이 잘못 되었습니다.", "전화번호는 필수입력 항목입니다.");
          return;
        }
      }

      var posData = {
        Tel: cRePhoneNum,
        AuthDI: oData.AuthDI,
      };

      axios
        .post(BasicInfo.UIL_API + "ResistByPhone", posData, {
          headers: {
          }
        })
        .then(res => {
          if (res.data.ResultCd === "00") {
            this.$store.dispatch('NationAPI');

            this.bAgree = false;
            this.bCardOrder = 3;
            
            this.editedItem.cCustomNm = oData.RSLT_NAME;
            this.editedItem.cBirth = oData.RSLT_BIRTH;
            this.editedItem.cAuthType = oData.AuthType;
            this.editedItem.cAuthDI = oData.AuthDI;
            this.editedItem.cCode = oData.Code;
            this.editedItem.cTel = cRePhoneNum;

            EventBus.$emit("onShowMsg",false,  "본인인증이 완료 되었습니다.");
            setTimeout(() => {
              this.$refs.IdRef.focus()
            }, 10);
          } else if (res.data.ResultCd == "02") {
            this.bAgree = false;
            this.Close();
            EventBus.$emit("onShowMsgBox","이미 가입된 회원정보가 있습니다.","이미 사용중인 회원이 있습니다. 확인 후 회원가입을 진행하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    // Nextpage2(){
    //   if (!this.bAuthIng) {
    //     EventBus.$emit("onShowMsgBox", "최소 1회의 인증이 필요합니다.","인증번호 발급을 먼저 진행하여 주세요.");
    //     return
    //   }

    //   var posData = {
    //     Tel : this.editedItem.cTel,
    //     Code : this.cCode,
    //   };

    //   axios
    //     .post(BasicInfo.UIL_API + "CheckAuthNum", posData, {
    //       headers: {}
    //     })
    //     .then(res => {
    //       if (res.data.ResultCd == "00") {
    //         this.ResetCertify();
    //         clearInterval(this.interval)
    //         this.$store.dispatch('NationAPI');
    //         this.bCardOrder= 4;
    //         EventBus.$emit("onShowMsg",false, "인증이 완료 되었습니다.");
    //       } else if (res.data.ResultCd == "02") {
    //         EventBus.$emit("onShowMsgBox","인증번호가 일치하지 않습니다.","입력하신 인증번호를 확인 하여 주세요.");
    //       } else {
    //         EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
    //       }
    //     })
    //     .catch(err => {
    //       EventBus.$emit("onShowMsg",true, ""+err);        
    //     });
    // },

    // 다이올로그 취소시 닫음 (0.3초가 지나면 디폴트값으로 넣어줌)
    Close() {
      this.bDialog = false;
      this.bCardOrder = 0
      this.NowSelFile = null;
      this.sNowPath = "";
      this.oCheckEmail = {bResult : false, cEmail : ""}
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    // 협력업체 찾기 다이올로그 띄우기
    SearchCorpDialog() {
      this.$refs.SearchCorpRef.Open("Resist",this.editedItem.cCorpNm);
    },

    // 협력업체 찾기 결과 받아오기
    GetCorpInfo(Data) {
      if (Data.cCorpNmKor != undefined || Data.cCorpNmEng != undefined) {
        if (Data.cLocal == "Y") {
          this.editedItem.cCorpNm = Data.cCorpNmKor
        } else {
          this.editedItem.cCorpNm = Data.cCorpNmEng
        }

        this.editedItem.cCorpId = Data.cCorpId
        this.editedItem.cLocal = Data.cLocal
      } else {
        this.bDialog = false;
        this.$emit("CloseLogin")
      }
    },
  }
};
</script>

<style type="text/css" scoped>
  .test_password_style {
    -webkit-text-security:disc; 
  }

  div :deep(.v-messages__message) {
    -webkit-text-security:none;
  }

  div :deep(.v-input__append-inner) {
    -webkit-text-security:none;
  }

  .input_english :deep(.v-input__slot) {
    /* .essetial_input :deep(.v-input__slot) { */
    /* -webkit-ime-mode:active;
    -moz-ime-mode:active;
    -ms-ime-mode:active; */
    ime-mode: disabled;
  }
  
  input[type="text"] {
    ime-mode: disabled !important;
  }
  /* div ::v-deep .v-messages__message{
    -webkit-text-security:none;
  } */

</style>
